export const RESET_FILTER = 'RESET_FILTER';

export const SET_TASKS = 'taskOverview/SET_TASKS';

export const RESET_TASKS = 'taskOverview/RESET_TASKS';

export const CHANGE_QUICK_FILTER = 'taskOverview/CHANGE_QUICK_FILTER';

export const RESET = 'taskOverview/RESET';

export const SET_PROGRESS = 'taskOverview/SET_PROGRESS';

export const COMPLETE_PROGRESS = 'taskOverview/COMPLETE_PROGRESS';
